import React, { useEffect, useState } from "react"
import { Container, Row, Col } from "reactstrap"
import MetaTags from "react-meta-tags"

//Import Components
import CardUser from "./card-user"
import CardWelcome from "./card-welcome"
import MiniWidget from "./mini-widget"

import SalesAnalytics from "./sales-analytics"
//import TotalSellingProduct from "./total-selling-product"
import Tasks from "./tasks"
//import ChatBox from "./chat-box"
import Notifications from './notifications';
import Oerview from './overview';
import User from "./user"

import axios from "axios";
import * as url from "helpers/url_helper";
import { HRConfig, formatDate } from "helpers/backend_helper";
import BirthdaysReports from "./birthdays"

const Dashboard = props => {
  const [state, setState] = useState({});
  const [approvals, setApprovals] = useState([]);
  const [loading, setLoading] = useState(true);

  const [username, setusername] = useState("")
  const [employeeNo, setEmployeeNo] = useState("")
  const [role, setrole] = useState("")

  const [pendingApprovals, setPendingApprovals] = useState(0)
  const [pendingAppraisals, setPendingAppraisals] = useState("-")
  const [yourLRequests, setYourLRequests] = useState("-")

  const [RRs, setRRs] = useState("-")
  const [TRs, setTRs] = useState("-")
  const [IPAs, setIPAs] = useState("-")
  const [IPs, setIPs] = useState("-")
  const [exits, setExits] = useState("-")
  const [handOvers, setHandOvers] = useState("-")

  const [contracts, setContracts] = useState([])
  const [birthdays, setBirthdays] = useState([])

  const [yourLeaves, setYourLeaves] = useState([])
  const [appraiserRatings, setAppraiserratings] = useState('-')

  

  const fetchData = () =>{
    if (localStorage.getItem("authMildUser")) {
      const obj = JSON.parse(localStorage.getItem("authMildUser"));
      setusername(obj.staffname)
      setrole(obj.title)

      axios.get(`${url.PURCHASES1}?$filter=requestorNo eq '${obj.uid}'and status eq 'Open' &company='${obj.activeCompany}'`, HRConfig).then((r)=>{ setRRs(r.data.value.length) }).catch((e)=>{ console.log(e) })
      axios.get(`${url.TIMESHEETS}?$filter=employeeNo eq '${obj.uid}'and status eq 'Open '&company='${obj.activeCompany}'`, HRConfig).then((r)=>{ setExits(r.data.value.length) }).catch((e)=>{ console.log(e) })
      axios.get(`${url.IPAS_X}?$filter=EmployeeNo eq '${obj.uid}'&company='${obj.activeCompany}'`, HRConfig).then((r)=>{ setIPAs(r.data.value.length) }).catch((e)=>{ console.log(e) })
      axios.get(`${url.APPROVALS}?$filter=approverId eq '${obj.username}' and Status eq 'Open'&company='${obj.activeCompany}'`, HRConfig).then((r)=>{ setApprovals(r.data.value), setPendingApprovals(r.data.value.length) }).catch((e)=>{ console.log(e) })
      axios.get(`${url.EMPLOYEES2}?$filter=No eq '${obj.uid}'&company='${obj.activeCompany}'`,  HRConfig)
        .then((r)=>{ 
            const leave = [
              {
                'leaveType': 'Annual', 
                'entitled':(r.data.value[0].AnnualLeaveDaysEntitlement),
                'used': (r.data.value[0].AnnualLeaveDaysUsed),
                'balance': (r.data.value[0].AnnualLeaveDaysEntitlement) - (r.data.value[0].AnnualLeaveDaysUsed)

              },
              {
                'leaveType': 'Bereavement', 
                'entitled':(r.data.value[0].CompationateLeaveEntitlement),
                'used': (r.data.value[0].CompassionateDaysUsed),
                'balance': (r.data.value[0].CompationateLeaveEntitlement)-(r.data.value[0].CompassionateDaysUsed)
              },
              {
                'leaveType': 'Sick', 
                'entitled':(r.data.value[0].SickLeaveEntitilement),
                'used': (r.data.value[0].SickLeaveDaysused),
                'balance': (r.data.value[0].SickLeaveEntitilement)-(r.data.value[0].SickLeaveDaysused)
              },
              {
                'leaveType': 'Study', 
                'entitled':(r.data.value[0].StudyLeaveEntitlement),
                'used': (r.data.value[0].StudyLeaveDaysUsed),
                'balance': (r.data.value[0].StudyLeaveEntitlement)-(r.data.value[0].StudyLeaveDaysUsed)
              },                                {
                  'leaveType': 'UnPaid', 
                  'entitled':(r.data.value[0].UnpaidLeaveEntitlement),
                  'used': (r.data.value[0].UnPaidDaysUsed),
                  'balance': (r.data.value[0].UnpaidLeaveEntitlement)-(r.data.value[0].UnPaidDaysUsed)
                }
            ];
            if(r.data.value[0].gender == 'Male'){
              leave.push(
                {
                  'leaveType': 'Paternity', 
                  'entitled': (r.data.value[0].PaternityLeaveEntitlement),
                  'used': (r.data.value[0].PaternityDaysUsed),
                  'balance': (r.data.value[0].PaternityLeaveEntitlement) - (r.data.value[0].PaternityDaysUsed)
                }
              )
            }else{
              leave.push(
                {
                  'leaveType': 'Maternity', 
                  'entitled': (r.data.value[0].MaternityLeaveEntitilement),
                  'used': (r.data.value[0].MaternityDaysUsed),
                  'balance': (r.data.value[0].MaternityLeaveEntitilement) - (r.data.value[0].MaternityDaysUsed)
                }
              )
            }
            setYourLeaves(leave)
          }).catch((e)=>{ console.log(e); });
    }
  }

  useEffect(() => {
    fetchData();
    return () => {
      setState({}); 
    };
  }, []);

  const reports = [
    {
      icon: "mdi mdi-cart-arrow-down mdi-16px",
      title: "Purchase Requisitions",
      value: RRs,
      color: "primary"
      
    },
    {
      icon: "mdi mdi-teach",
      title: "Trainings",
      value: TRs,
      color: "primary"
    },
    {
      icon: "mdi mdi-form-select",
      title: "IPAs",
      value: IPAs,
      color: "primary"

    },
    {
      icon: "mdi mdi-cash-refund",
      title: "Payment Requisitions",
      color: "primary",
      value: IPs
    }
    ,
    {
      icon: "mdi mdi-calendar-clock mdi-16px",
      title: "Open Timesheets",
      value: exits,
      color: "primary",
    },
    ,
    {
      icon: "mdi mdi-car-multiple",
      title: "Fleet Requisitions",
      value: handOvers,
      color: "primary",
    }
];

  
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>
            Home | BRIDGE
          </title>
        </MetaTags>
        <Container fluid>
           <CardUser username={username} role={role} pendingApprovals={pendingApprovals} pendingAppraisals={appraiserRatings} yourLRequests={yourLRequests} /> 
            <Row>
              <CardWelcome />
                <Col xl="8">
                <User reports={reports}/>
                </Col>
            </Row>

            <Row> 
              <Col xl="4">
                  <Notifications birthdays={birthdays} showApprovals={false}/>
              </Col>
              <Col xl="3">
                <BirthdaysReports showReports={true} />
              </Col>
              <Col xl="5">
                <Tasks leave={yourLeaves} showReports={true} />
              </Col>
            </Row>
            
          
          
          
          <Row>
          
            
            {/*<SalesAnalytics contracts ={contracts} />*/}
            
          </Row>
          
     
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Dashboard
